import { createContext, useEffect, useState, useMemo, useRef } from 'react';
import __isEmpty from 'lodash/isEmpty';
export const ModalContext = createContext();

const FULL_SCREEN = 'full-screen';

const defaultOptions = {
    mode: FULL_SCREEN
};

const ModalProvider = (props) => {
    const { children } = props;

    const [openModal, setOpenModal] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [optionsModal, setOptionsModal] = useState(defaultOptions);
    const optionsModalRef = useRef({});
    const focusPage = useRef({
        currentFocus: null,
        lastFocusOnPage: null
    });

    const setModal = (content, options = defaultOptions) => {
        focusPage.current.lastFocusOnPage = focusPage.current.currentFocus;
        options = { ...defaultOptions, ...options };
        optionsModalRef.current = options;
        setOpenModal(true);
        setOptionsModal(options);
        setModalContent(content);

        if (typeof document !== 'undefined' && optionsModalRef?.current?.mode === FULL_SCREEN) {
            document.body.classList.add('is-modal-fullscreen');
            document.getElementById('__mainContentInner').setAttribute('inert', true);
        }
    };

    const removeModal = () => {
        document.getElementById('__mainContentInner').removeAttribute('inert');
        setTimeout(() => {
            focusPage.current.lastFocusOnPage?.focus();
            focusPage.current.lastFocusOnPage = null;
        }, 0);
        if (typeof document !== 'undefined' && optionsModalRef?.current?.mode === FULL_SCREEN) {
            document.body.classList.remove('is-modal-fullscreen');
        }
        optionsModalRef.current = {};
        setOpenModal(false);
        setModalContent(null);
    };

    const handleFocusin = (e) => {
        focusPage.current.currentFocus = e.target;
    };

    useEffect(() => {
        document.addEventListener('focusin', handleFocusin);

        return () => {
            document.removeEventListener('focusin', handleFocusin);
        };
    }, []);

    useEffect(() => {
        if (!__isEmpty(optionsModalRef?.current)) {
            if (optionsModalRef?.current?.mode === FULL_SCREEN) {
                document.body.style.overflow = openModal ? 'hidden' : 'auto';
                return () => {
                    document.body.style.overflow = 'auto';
                };
            }
        }
    }, [openModal]);

    const contextValue = useMemo(
        () => ({
            openModal,
            modalContent,
            optionsModal,
            setModal,
            removeModal
        }),
        [modalContent, optionsModal]
    );

    return <ModalContext.Provider value={contextValue}>{children}</ModalContext.Provider>;
};

export default ModalProvider;
